import auth from "../middleware/auth";
import guest from "../middleware/guest";

export default [
  {
    path: "/integrations/api/index",
    name: "integrations",
    component: () => import("./../views/integrations/api/Index.vue"),
    meta: {
      middleware: [auth],
      breadcrumb: [
        {
          title: "Home",
          url: "/"
        },
        {
          title: "Интеграционный шлюз",
          i18n: "navmenu.integration_gateway.index",
          active: true
        },
        {
          title: "Список API",
          i18n: "navmenu.integration_gateway.API_list",
          active: true
        },
      ]
    },

    pageTitle: "Интеграционный шлюз",
    rule: "editor"
  }
]
